import { createAction, props } from '@ngrx/store';
import { FilterItem } from '@fc-vehicles/components/shared/vehicle-filter/vehicles-filter.component';
import { VehicleType } from '@fc-core';
import { SearchBy } from '../reducers/vehicle-filters.reducer';
import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export const initVehicleFilters = createAction(
  '[VehicleFilters] Init Vehicle Filters',
  props<{ vehicleTypes: VehicleType[] }>(),
);
export const setSearchVehicleText = createAction(
  '[VehicleFilters] Set Search Vehicle Text',
  props<{ searchText: string }>(),
);

export const setVehicleSortBy = createAction(
  '[VehicleFilters] Set Vehicle Sort By ',
  props<{ sortBy: SortBy }>(),
);
export const setVehiclesFilter = createAction(
  '[VehicleFilters] Set Vehicles Filter',
  props<{ filterItem: FilterItem }>(),
);

export const setManyVehicleFilters = createAction(
  '[VehicleFilters] Set Many Vehicle Filters',
  props<{ filters: FilterItem[] }>(),
);

export const resetDefaultVehicleFilters = createAction(
  '[VehicleFilters] Reset Default Vehicle Filters',
);

export const setVehicleSearchByFields = createAction(
  '[VehicleFilters] Set Vehicle Search By Fields',
  props<{ searchFields: SearchBy[] }>(),
);
